export function nameFormatting(...names: (string | undefined)[]) {
	const formattedNames = names
		.filter((name) => name !== undefined)
		.map((name) => {
			const words = (name || '').split(' ');
			const formattedWords = words.map((word) =>
				word
					.split(/([-'])/)
					.map((part) => {
						if (part === '-' || part === "'") {
							return part;
						}

						return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
					})
					.join('')
			);
			return formattedWords.join(' ');
		});
	return formattedNames.join(' ');
}

export function extractCountryNames(countryInfo: string) {
	const countryNames = countryInfo.split('|').map((item) => {
		const parts = item.trim().split(/\s+/);
		if (parts.length > 1) {
			parts.shift();
		}
		return parts.join(' ');
	});

	return countryNames.join(' | ');
}

export interface FormatSubjectNameOptions {
	showIco?: boolean;
	suffix?: string;
}

export const formatSubjectName = (
	osoba:
		| { nazev?: string; ico?: number }
		| { jmeno?: string; prijmeni?: string }
		| undefined,
	{ showIco = true, suffix }: FormatSubjectNameOptions = {}
) => {
	const withSuffix = (name: string) =>
		name && suffix ? `${name}: ${suffix}` : name;

	if (!osoba) {
		return '-';
	}
	if ('nazev' in osoba || 'ico' in osoba) {
		const nazev = osoba.nazev?.trim();
		if (showIco && osoba.ico && nazev) {
			return withSuffix(`${nazev} (${osoba.ico?.toString()})`);
		}
		return nazev ? withSuffix(nazev) : '-';
	} else if ('jmeno' in osoba || 'prijmeni' in osoba) {
		const jmenoPrijmeni = nameFormatting(osoba.jmeno, osoba.prijmeni).trim();
		return jmenoPrijmeni ? withSuffix(jmenoPrijmeni) : '-';
	}
	return '-';
};
